import { bandPanelsXY } from "@/lib/bands";
import { cellAt, visibleCells } from "@/lib/geometry";
import { infillOf } from "@/lib/infill";

export function effGlassMap(item) {
  const map = {};
  ["top", "left", "right"].forEach((side) => {
    const g = item.band_glass?.[side];
    if (!g) return;
    bandPanelsXY(item, side).forEach((p) => { const { r, c } = cellAt(item, p.x0, p.y0); map[`${r}-${c}`] = g; });
  });
  Object.entries(item.panel_glass || {}).forEach(([k, v]) => { if (v) map[k] = v; });
  return map;
}

export const decorate = (item) => ({ ...item, _eff_glass: effGlassMap(item) });
export const glassOf = (item, r, c) => (item._eff_glass ?? effGlassMap(item))[`${r}-${c}`] || item.glass_spec;

export function infillsUsed(item) {
  const seen = new Map();
  visibleCells(item).forEach(({ r, c }) => {
    const spec = glassOf(item, r, c), inf = infillOf(spec);
    if (inf && !seen.has(spec)) seen.set(spec, { ...inf, spec });
  });
  return [...seen.values()];
}
